import connect from "react-redux/es/connect/connect";
export default connect;